     <div style="margin-top: 40px; text-align: center;" *ngIf="location">
       <h3 style="margin-bottom: 4px;">{{location.subdivision_name}} - {{location.lot}} ({{location.street_address}})</h3>
       <p style="font-size: 10px; color: #8b9394; margin: 0 0 16px 0;">{{location.location_id}}</p>

       <div style="display: inline-block; text-align: left; margin-bottom: 16px;">
         <p style="font-weight: 700; font-size: 14px; margin: 0;">Scope: <span style="font-size: 18px;">{{displayScope}}</span>
           <span style="padding-left: 2em;">Pathway: <span style="font-size: 18px;">{{displayPathway}}</span></span>
           <span *ngIf="displayStories" style="padding-left: 2em;">Stories: <span style="font-size: 18px;">{{displayStories}}</span></span></p>
         <p *ngIf="displayScope2" style="font-weight: 700; font-size: 14px; margin: 0;">Scope: <span style="font-size: 18px;">{{displayScope2}}</span>
           <span style="padding-left: 2em;">Pathway: <span style="font-size: 18px;">{{displayPathway2}}</span></span></p>
         <p *ngIf="displayScope3" style="font-weight: 700; font-size: 14px; margin: 0;">Scope: <span style="font-size: 18px;">{{displayScope3}}</span>
           <span style="padding-left: 2em;">Pathway: <span style="font-size: 18px;">{{displayPathway3}}</span></span></p>
       </div>

       <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 20px;">
         <button mat-raised-button (click)="openAddJob()">New+</button>
         <button mat-raised-button (click)="openAddJob(true)">Audit+</button>
         <button mat-raised-button *ngIf="location.form_id" (click)="openJobFormLocmain(location)"
           style="background: #8cc63f; color: white;">
           <fa-icon [icon]="faclipboard" style="margin-right: 5px;"></fa-icon>Rater Form
         </button>
         <button mat-raised-button title="Get form logs" (click)="onLogClick(location, true)">
           <fa-icon [icon]="faScroll" style="margin-right: 5px;"></fa-icon>Logs
         </button>
         <button mat-raised-button [matTooltip]="location?.has_extra_notes ? 'Extra Notes (has notes)' : 'Extra Notes'"
                 [class.notes-flag]="location?.has_extra_notes" (click)="openExtraNotes(location)">
           <fa-icon [icon]="facomments" style="margin-right: 5px;"></fa-icon>Extra Notes
         </button>
       </div>

       <div style="margin-bottom: 20px;">
         <mat-slide-toggle style="color: #8b9394;" labelPosition="before" [disabled]="isPaused" [(ngModel)]="timefunctions">
           <span *ngIf="!isPaused">Time Functions</span>
           <span *ngIf="isPaused">Time Functions Unavailable</span>
         </mat-slide-toggle>
         <div *ngIf="timefunctions">
           <p class="jumplink" (click)="viewTimeCard()">View Timecard</p>
         </div>
       </div>
     </div>
     <div style="max-width: 700px; margin: 0 auto;">
      <div *ngFor="let job of jobs; index as i;" class="jobBlock" style="
        padding: 20px 24px;
        background: white;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        margin-bottom: 24px;
        border-left: 4px solid #8cc63f;">

        <!-- Card Header -->
        <h5 style="text-align: center; font-size: 22px; font-weight: 600; margin: 0 0 12px 0; color: #424242;">
          {{job.customer_name ? job.customer_name.trim() : ''}} - {{job.customer_jobtype ? job.customer_jobtype.trim() : ''}}
        </h5>

        <!-- Date & Status Row -->
        <div style="display: flex; justify-content: space-evenly; align-items: center; margin-bottom: 8px;">
          <p style="font-size: 16px; font-weight: 500; margin: 0; color: #424242;">
            {{job.flex_start_date ? 'FLEX' : job.schedule_date ? job.schedule_date.substring(0,10) : '' }}
          </p>
          <p *ngIf="job.job_status !== null && !job.job_status.toLowerCase().includes('fail')"
            style="font-size: 16px; font-weight: 600; color: #8cc63f; margin: 0;">
            {{job.job_status}}
          </p>
          <button class="blink_me" mat-button color="warn"
            *ngIf="job.job_status !== null && job.job_status.toLowerCase().includes('fail')"
            (click)="openFailNotes(job)" style="font-size: 14px;">
            {{job.job_status}}
          </button>
        </div>

        <!-- Assignment Info -->
        <div style="text-align: center; font-size: 14px; color: #666; margin-bottom: 12px; line-height: 1.6;">
          <span><b>Assigned to:</b> {{job.employee_name ? job.employee_name.trim() : ''}}</span>
          <span style="margin-left: 12px;"><b>Manager:</b> {{job.name}}</span>
        </div>

        <!-- EPO -->
        <div style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 16px;">
          <span style="font-size: 14px; font-weight: 500; color: #424242;">EPO?</span>
          <input style="height: 18px; width: 18px; cursor: pointer;" type="checkbox"
            (change)="epoUpdated(job)" [checked]='job.eporeqstd'>
        </div>

        <!-- Action Buttons -->
        <div style="display: flex; justify-content: center; gap: 4px; flex-wrap: wrap; padding: 8px 0; border-top: 1px solid #eee;">
          <button *ngIf='!job.isaudit' mat-icon-button title="Edit" (click)="openEditJob(job, i)">
            <fa-icon [icon]="faedit" style="color: #424242;"></fa-icon>
          </button>
          <button *ngIf='job.isaudit' mat-icon-button title="Edit" (click)="openEditJob(job, i, true)">
            <fa-icon [icon]="faedit" style="color: #424242;"></fa-icon>
          </button>
          <button mat-icon-button title="Delete" (click)="deleteJob(job, i)">
            <fa-icon [icon]="fatrash" style="color: #E57373;"></fa-icon>
          </button>
          <button mat-icon-button title="Send Results Email (coming soon)">
            <fa-icon [icon]="faenvelope" style="color: #9575CD;"></fa-icon>
          </button>
          <button *ngIf='job.form_id' mat-icon-button title="Open Rater Form" (click)="openJobForm(job)">
            <fa-icon [icon]="faclipboard" style="color: #8cc63f;"></fa-icon>
          </button>
          <button mat-icon-button title="Job Photos" (click)="onPhotosClick(job)">
            <fa-icon [icon]="facamera" style="color: #424242;"></fa-icon>
          </button>
          <button mat-icon-button title="Copy Job" (click)="copyJob(job)">
            <fa-icon [icon]="fahvac" style="color: #424242;"></fa-icon>
          </button>
          <!-- Clock in/out. *ngIf conditions kept byte-identical to location.component.html's
               #timeButtons block: "clocked in" means clockedin OR my id is in participants,
               because a second rater on a shared job sees clockedin=true from someone else. -->
          <ng-container *ngIf="timefunctions">
            <button class="clock"
              *ngIf="(job.clockedin == false || job.clockedin == null || !isParticipant(job.participants, employeeID)) && !isPaused"
              [disabled]="areTimeButtonsDisabled" (click)="updateStartTimeNew(job)"
              title="Clock In"
              style="width: 3em; border-color: #dfdfdf; border-radius: 1em; height: 40px; background: #d3d3d3;">
              <i style="color: #8cc63f; font-size: 24px;" class="fa fa-solid fa-clock"></i>
            </button>
            <button class="clock active"
              *ngIf="job.clockedin == true || isParticipant(job.participants, employeeID)"
              [disabled]="areTimeButtonsDisabled" (click)="updateEndTimeNew(job)"
              title="Clock Out"
              style="width: 3em; border-color: #dfdfdf; border-radius: 1em; height: 40px; background: #d3d3d3;">
              <i class="fa fa-solid fa-clock" style="color: red; font-size: 24px;"></i>
            </button>
          </ng-container>
        </div>

        <!-- Notes -->
        <div style="margin-top: 12px; font-size: 14px; color: #555;">
          <p *ngIf="job.job_notes" style="margin: 4px 0;"><b>Job Notes:</b> {{job.job_notes}}</p>
          <p *ngIf="job.billing_note" style="margin: 4px 0;"><b>Billing Notes:</b> {{job.billing_note}}</p>
          <p *ngIf="job.customer_jobtype !== null && job.customer_jobtype.toLowerCase().includes('final')"
            style="margin: 4px 0; text-align: center;">
            <b>Final Notes:</b> {{job.finalnotes4builder || "no notes"}}
          </p>
        </div>

      </div>
    </div>
